import type { AnnualCrossTopicDetailRow } from './annualProgressCrossTopicExtract';

const valuesRegistry = new Map<string, string[]>();
const detailRegistry = new Map<string, AnnualCrossTopicDetailRow[]>();

function registryKey(workspaceId: string, academicYear: number, gradeId: string, termNumber: 1 | 2): string {
  return `${workspaceId.trim()}|${academicYear}|${gradeId.trim()}|${termNumber}`;
}

export function publishAnnualProgressCrossTopics(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  termNumber: 1 | 2,
  progressCrossValues: string[]
): void {
  const gid = gradeId.trim();
  const ws = workspaceId.trim();
  if (!ws || !gid) return;
  valuesRegistry.set(registryKey(ws, academicYear, gid, termNumber), progressCrossValues);
}

export function readAnnualProgressCrossTopics(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  termNumber: 1 | 2
): string[] | null {
  const gid = gradeId.trim();
  const ws = workspaceId.trim();
  if (!ws || !gid) return null;
  return valuesRegistry.get(registryKey(ws, academicYear, gid, termNumber)) ?? null;
}

export function publishAnnualProgressCrossTopicDetailRows(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  termNumber: 1 | 2,
  detailRows: AnnualCrossTopicDetailRow[]
): void {
  const gid = gradeId.trim();
  const ws = workspaceId.trim();
  if (!ws || !gid) return;
  detailRegistry.set(registryKey(ws, academicYear, gid, termNumber), detailRows);
}

export function readAnnualProgressCrossTopicDetailRows(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  termNumber: 1 | 2
): AnnualCrossTopicDetailRow[] | null {
  const gid = gradeId.trim();
  const ws = workspaceId.trim();
  if (!ws || !gid) return null;
  return detailRegistry.get(registryKey(ws, academicYear, gid, termNumber)) ?? null;
}

export function clearAnnualProgressCrossTopicsForTerm(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  termNumber: 1 | 2
): void {
  const gid = gradeId.trim();
  const ws = workspaceId.trim();
  if (!ws || !gid) return;
  const key = registryKey(ws, academicYear, gid, termNumber);
  valuesRegistry.delete(key);
  detailRegistry.delete(key);
}
